// let md = new MobileDetect(window.navigator.userAgent);
let ua = detector.parse(navigator.userAgent);
let util = require('../../common/util');
let docomchannel = {
  getAppChannel: function(appChannel, downlist) {
    let downList, downObj, downKey, downArr, newAppChannel;

    downObj = {};
    downKey = appChannel.replace(/\d/gi, '');
    downList = downlist || ['xhqb01', 'shuisj00', 'jingy00', 'daikwy00', 'fengs00', 'jielm00', '51xyk00', 'rongzj00', 'sudzj00'];


    downList.forEach(function(item) {
      let key = item.replace(/\d/gi, '');
      downObj[key] = downObj[key] || [];
      downObj[key].push(item);
    });

    downArr = downObj[downKey] || [];

    if (downArr.indexOf(appChannel) > -1) {
      newAppChannel = appChannel;
    } else {
      if (downArr.indexOf(downKey + '00') > -1) {
        newAppChannel = downKey + '00';
      } else {
        newAppChannel = 'xhqb01';
      }
    }

    return newAppChannel;
  },
  getParamsObj: function() {
    //注册所需传送字段
    let deviceID = util.storage.get('fppDeviceId') ? util.storage.get('fppDeviceId') : Guid.create().value;
    //兼容无痕模式，防止报错  原因：兼容无痕模式操作cookie会报错
    try {
      util.storage.set('fppDeviceId', deviceID, {expires: 30, path: '/'});
    } catch (e) {}

    let deviceType = ua.device.family;
    let appChannel = util.getParam('appChannel');
    let appPostChannel = appChannel;
    let deviceName = ua.device.name;
    let clientPlatform = ua.os.family;
    let brand = ua.device.manufacturer;
    let osversion = ua.os.version;

    //浏览器分辨率
    let devicePixelRatio = window.devicePixelRatio;
    let screen = window.screen;
    let resolution = (screen.width * devicePixelRatio) + 'X' + (screen.height * devicePixelRatio);
    let channelName = 'WEB';

    //请求验证码及注册传递参数
    let paramsObj = {
      deviceID: deviceID,
      deviceType: deviceType,
      appChannel: appPostChannel,
      deviceName: deviceName,
      clientPlatform: clientPlatform,
      brand: brand,
      osversion: osversion,
      resolution: resolution,
      channelName: channelName
    };

    // 添加注册referral_type
    // let referralCode = util.getParam('referralCode');
    paramsObj['referralType'] = 'MGM01'
    this.paramsObj = paramsObj;
    return paramsObj;
  }
};
module.exports = docomchannel;



// WEBPACK FOOTER //
// ./web/js/mgm/common/dochannel.js